import SuccessIcon from 'assets/images/VerifySuccess/success.svg';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Platform, StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import TitleXLText from 'shared/components/vxl/typography/primary/title/TitleXLText';
import theme from 'shared/styles/theme';

const CstVerifySuccess = () => {
  const insets = useSafeAreaInsets();
  const { t: translatedText } = useTranslation('cstVerify');

  const getScreenContent = () => {
    return {
      title: translatedText('success.title'),
      body: translatedText('success.body'),
    };
  };

  const { title, body } = getScreenContent();

  return (
    <View
      style={[
        styles.container,
        { paddingTop: insets.top, paddingBottom: insets.bottom },
      ]}
    >
      <View style={styles.content}>
        <View style={styles.iconWrapper}>
          <SuccessIcon width={240} height={240} />
        </View>

        <TitleXLText style={styles.titleLink}>{title}</TitleXLText>
        <BodyBaseText style={styles.subtitleLink}>{body}</BodyBaseText>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.color.background.primary,

    ...(Platform.OS === 'web' && {
      minHeight: '100vh',
      width: '100%',
      maxWidth: '100vw',
      alignSelf: 'center',
    }),
  },

  content: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    paddingHorizontal: theme.spacing.l,
  },

  iconWrapper: {
    marginBottom: theme.spacing.m,
  },

  titleLink: {
    ...theme.typography.expressive.xl,
    textAlign: 'center',
    marginBottom: theme.spacing.m,
  },

  subtitleLink: {
    color: theme.color.text.primary,
    textAlign: 'center',
  },
});

export default CstVerifySuccess;
